import universal from 'react-universal-component';

export default universal(() => import('./StrengthOfSchedule'));



// WEBPACK FOOTER //
// ./src/app/views/StrengthOfSchedule/index.js